var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDepartments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 116,
    viewBox: "0 0 136 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111.626,
    y: 37.9531,
    width: 17.0451,
    height: 20.0988,
    rx: 4.6281,
    transform: "rotate(90 111.626 37.9531)",
    fill: "#E5E7EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5288,
    y: 37.9531,
    width: 17.0451,
    height: 20.0988,
    rx: 4.6281,
    transform: "rotate(90 85.5288 37.9531)",
    fill: "#E5E7EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4312,
    y: 37.9531,
    width: 17.0451,
    height: 20.0988,
    rx: 4.6281,
    transform: "rotate(90 59.4312 37.9531)",
    fill: "#E5E7EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 111.626,
    y: 60.9531,
    width: 17.0451,
    height: 20.0988,
    rx: 4.6281,
    transform: "rotate(90 111.626 60.9531)",
    fill: "#E5E7EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85.5288,
    y: 60.9531,
    width: 17.0451,
    height: 20.0988,
    rx: 4.6281,
    transform: "rotate(90 85.5288 60.9531)",
    fill: "#E5E7EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4312,
    y: 60.9531,
    width: 17.0451,
    height: 20.0988,
    rx: 4.6281,
    transform: "rotate(90 59.4312 60.9531)",
    fill: "#E5E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2827 54.5874L2.10131 62.7688",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.104 54.5903L10.2854 62.7717",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.899 2.36328L126.431 9.83142",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.429 2.36572L133.897 9.83386",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.4453,
    cy: 107.852,
    r: 5.78512,
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDepartments);
export default __webpack_public_path__ + "static/media/NoDepartments.f35a210af578ccbfa8a3234cd9fddece.svg";
export { ForwardRef as ReactComponent };